import Card from '@alliancesafetycouncil/asc-card';
import PageTitle from '@alliancesafetycouncil/asc-page-title';
import Table from '@alliancesafetycouncil/asc-table';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { getUsers } from '../../../actions/Users/Users';
import { TitleBumper } from '../../../components/common';

class Users extends Component {
  constructor(props) {
    super(props);
    this.state = {
      params: {
        direction: 'asc',
        limit: 1000,
        offset: 0,
        sort: 'id',
      },
      columnDefs: [
        { headerName: 'User', field: 'name', cellRenderer: 'renderName' },
        { headerName: 'Company', field: 'company' },
        { headerName: 'Role', field: 'roles' },
        { headerName: 'Muster Access', field: 'muster' },
        { headerName: 'Login Name', field: 'login' },
        { headerName: 'Notes', field: 'notes' },
        {
          headerName: 'Status',
          field: 'status',
          filter: 'agSetColumnFilter',
          valueFormatter: (params) => params.value.charAt(0).toUpperCase() + params.value.slice(1, params.value.length),
          filterParams: {
            newRowsAction: 'keep',
          },
        },
      ],
      customCells: {
        renderName: (row) => {
          const networkId = row.data.network ? `/${row.data.network.id}` : '/super';
          return <Link to={`/users/user-details/${row.data.id}${networkId}/details`}>{row.data.name}</Link>;
        },
      },
      config: [
        {
          type: 'primary',
          size: 'md',
          label: 'Add User',
          href: '/#/users/add-user',
        },
      ],
    };
  }

  componentDidMount() {
    const { direction, limit, offset, sort } = this.state.params;

    this.props.GetUsers(direction, limit, offset, sort);
  }

  render() {
    return (
      <Fragment>
        <Breadcrumb tag="nav" listTag="div">
          <BreadcrumbItem active> All Users</BreadcrumbItem>
        </Breadcrumb>
        <TitleBumper>
          <PageTitle icon="user">All Users</PageTitle>
        </TitleBumper>
        <Card type="main">
          <Table
            {...this.props}
            className="ag-theme-balham flex flex-1 flex-col relative text-sm"
            columnDefs={this.state.columnDefs}
            getData={this.props.GetCompanies}
            data={this.props.data}
            headerConfig={this.state.config}
            customCells={this.state.customCells}
            defaultColDef={this.state.defaultColDef}
            filter_type="any"
            getGridApi={this.getGridApi}
            enablePagination={false}
            defaultFilter={{ column: 'status', value: 'active' }}
            rowHeight={50}
          />
        </Card>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    busy: state.userService.busy,
    res: state.userService.res,
    err: state.userService.err,
    data: state.userService.data,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    GetUsers: (direction, limit, offset, sort) => dispatch(getUsers(direction, limit, offset, sort)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Users);
